module.exports = __webpack_public_path__ + "img/wechat-img6.59626254.png";